import { type ReactNode } from "react";
import { useResizable } from "../hooks/useResizable";
import { useLayoutContext } from "../contexts/LayoutContext";

/** Width of the collapsed sidebar (icon strip only). */
export const SIDEBAR_COLLAPSED_WIDTH = 64;

interface SidebarProps {
  children: ReactNode;
}

export default function Sidebar({ children }: SidebarProps) {
  const { state, dispatch } = useLayoutContext();
  const collapsed = !state.sidebarOpen;
  const configWidth = state.sidebarWidth;

  const {
    width: resizedWidth,
    isResizing,
    handleMouseDown,
  } = useResizable({
    initialWidth: configWidth,
    onWidthChange: (w) => {
      dispatch({ type: 'layout:setSidebarWidth', width: w });
    },
  });

  const displayWidth = collapsed ? SIDEBAR_COLLAPSED_WIDTH : resizedWidth;

  return (
    <aside
      id="sidebar"
      data-component="Sidebar"
      style={{
        width: displayWidth,
        transition: isResizing ? "none" : undefined,
      }}
      data-collapsed={collapsed || undefined}
    >
      {/* Drag handle on left edge */}
      {!collapsed && (
        <div
          className="sidebar-resize-handle"
          onMouseDown={handleMouseDown}
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            width: 6,
            cursor: "col-resize",
            zIndex: 'var(--z-canvas-ui)',
          }}
        />
      )}

      {children}
    </aside>
  );
}
